import React from 'react';
import { withNamespaces } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/styles';
import { Dialog, DialogContent, DialogTitle, Grid, IconButton } from '@material-ui/core';
import logo from 'dataModule/assets/img/HealthBeatsDialogLogo.svg';
const disclaimerPopUpImg = require('../assets/DisclaimerPopUp.png');

const styles = (theme) => ({
  dialogPaper: {
    minHeight: '600px',
    minWidth: '654px',
    borderRadius: '5px',
  },
  topHeader: {
    margin: 0,
    padding: 2,
    height: 64,
    backgroundColor: '#fff',
  },
  primaryColor: {
    color: '#ff5100',
  },
  listItem: {
    height: 'auto !important',
  },
  dialogLogo: {
    maxWidth: '40px',
  },
  dialogTitle: {
    color: '#212121',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '19px',
    letterSpacing: '0.15000000596046448px',
  },
  dialogCloseButton: {
    position: 'relative',
    left: '10px',
    color: 'black',
    maxHeight: '40px',
    maxWidth: '40px',
  },
  dialogDisplayFlex: {
    display: 'flex',
    alignItems: 'center',
    maxHeight: '40px',
    textIndent: 0,
  },
  dialogListItem: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '19px',
    color: '#212121',
    letterSpacing: '0.5px',
  },
  link: {
    marginLeft: 30,
  },
  icon: {
    marginRight: 8,
  },
  button: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '1.25px',
    textAlign: 'center',
    minWidth: 161,
  },
  tabRoot: {
    [theme.breakpoints.up('md')]: {
      minWidth: 80,
    },
    backgroundColor: '#fff',
    opacity: 'unset',
    height: 60,
    '&:hover': {
      color: '#2979ff',
      opacity: 1,
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  tabLabelContainer: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(),
      paddingRight: theme.spacing(),
    },
  },
  label: {
    textTransform: 'capitalize',
    color: '#212121',
    fontSize: '15px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: 1.2,
    fontStretch: 'normal',
    letterSpacing: '0.5px',
    '&:hover': {
      color: '#212121',
    },
  },
  indicator: { backgroundColor: '#ff5100' },
});

@withNamespaces('common', { wait: true })
@withStyles(styles, { index: 1 })
export default class DialogDisclaimer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
    };
  }

  handleClose = async () => {
    this.props.toggleDisclaimerDialog(false);
  };

  render() {
    const {
      open, t,
      classes: { dialogPaper, dialogLogo, dialogDisplayFlex, dialogTitle, dialogCloseButton },
    } = this.props;

    return (
      <Dialog open={open} classes={{ paper: dialogPaper }} aria-labelledby="ihealth-customer-care-info">
        <DialogTitle id="ihealth-customer-care-info" style={{ padding: '12px 16px' }}>
          <Grid container direction="row" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Grid item className={dialogDisplayFlex}>
              <img src={logo} className={dialogLogo} />
              <span style={{ width: '16px' }} />
              <Typography variant="body1" className={dialogTitle}>
                {t('disclaimerDialog.title')}
              </Typography>
            </Grid>
            <Grid item className={dialogDisplayFlex}>
              <IconButton aria-label="close" className={dialogCloseButton} onClick={this.handleClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent style={{ padding: '0' }}>
          <img src={disclaimerPopUpImg} style={{ width: '100%', height: '100%' }} />
          <div style={{ padding: 30 }}>
            <Typography style={{ lineHeight: '20px' }}>
              {t('disclaimerDialog.content.001')}
              <br />
              <br />
              {t('disclaimerDialog.content.002')}
              <br />
              <br />
              {t('disclaimerDialog.content.003')}
            </Typography>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}
